import { helperServices } from "../../shared/helper";
import history from "../../shared/utils/history";
import { apiFetch } from "../../shared/helper/apiFetch";

const basePath = "/api";

// -------------------- Logout --------------------
function logout() {
  localStorage.removeItem("user");
  history.push("/");
  window.location.reload();
}

// -------------------- Handle Response --------------------
function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    const token = response.headers.get("Authorization");

    if (token) {
      localStorage.setItem("token", JSON.stringify(token));
    }

    if (!response.ok) {
      if (response.status === 401) {
        logout(); // auto logout if 401 response returned from API
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

// -------------------- Helper: Build Headers --------------------
function buildHeaders(additionalHeaders = {}) {
  const accessToken = helperServices.getAuthorization() || "";
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: accessToken,
    ...additionalHeaders,
  };
}

// -------------------- Save Composition --------------------
function saveComposition(data, patientId, visitId, templateId, patientEhrid, notesDetails, procedure) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders({ Prefer: "return={representation|minimal}" }),
    body: JSON.stringify(data),
  };

  const procedureParam = encodeURIComponent(JSON.stringify(procedure));
  const url = `${basePath}/v1/Ehr/Composition/Create?patientId=${patientId}&visitId=${visitId}&templateId=${templateId}&patientEhrid=${patientEhrid}&notesDetails=${notesDetails}&procedure=${procedureParam}`;

  return apiFetch(url, requestOptions);
}

// -------------------- Get Template By ID --------------------
function getTemplateById(templateId, patientInfo, procedureData) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(patientInfo),
  };

  const procedureParam = procedureData ? encodeURIComponent(JSON.stringify(procedureData)) : "";
  const url = `${basePath}/v1/ehr/template/preview?templateId=${templateId}&procedure=${procedureParam}`;

  return apiFetch(url, requestOptions);
}

// -------------------- Get Suggestion By ID --------------------
function getSuggestionById(patientid, visitid) {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };

  const url = `${basePath}/v1/ehr/getPresSuggestions?patientid=${patientid}&visitid=${visitid}`;
  return apiFetch(url, requestOptions);
}

// -------------------- Get ICD-10 Values --------------------
function getIcd10Values() {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };

  const url = `${basePath}/v1/ehr/Composition/diagnosis/icd10`;
  return apiFetch(url, requestOptions);
}

// -------------------- Get Composition By Version UID --------------------
function getCompositionByVid(versionUid, patientEhrid) {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };

  const url = `${basePath}/v1/ehr/Composition/preview?versionUid=${versionUid}&patientEhrid=${patientEhrid}`;
  return apiFetch(url, requestOptions);
}

// -------------------- Push Prescription To ERP --------------------
function syncPrescriptionToErp(prescription) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(prescription),
  };

  return apiFetch(`${basePath}/v1/prescription/erp/sync`, requestOptions);
}

function deletePrescriptionFromErp(prescription) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(prescription),
  };

  return apiFetch(`${basePath}/v1/prescription/erp/delete`, requestOptions);
}

// -------------------- Export --------------------
const ehrServices = {
  saveComposition,
  syncPrescriptionToErp,
  deletePrescriptionFromErp,
  getTemplateById,
  getCompositionByVid,
  getIcd10Values,
  getSuggestionById,
};

export default ehrServices;
